import { NgModule } from '@angular/core';

import { LogoComponent } from './Logo.component';

@NgModule({
  declarations: [LogoComponent],
  exports: [LogoComponent],
})
export class LogoModule {}
